module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUxpcQCI/wCF/wCH/wCI/wCF/wCF/wCF/wCG/wCE/wCF/wCF/wCF/wCG/wCG/wCM/wCE/wCF/wCF/wCF/wCE/wD//wCF/wCF/wCE//i9vFoAAAAYdFJOUwAi6SwZ8Nj6QvV9T+E3WxDQZ3CLnAHDr7cCsdMAAACtSURBVDjLtdRLDoQgEARQFFFAVMQf9z/pjDjbKohk2L6kF01XCenVvgj4fIzxxK4i9e3m6JEf++Md977j83PuGuS2yFuJPGR8Ta4m5HPOh9uNRj4W+TAi16bIZ+RT+v+4vnXZJg8Zt8gbV+Qb8q5//OAO5y/JFV9fz5ermZpXys+iRNFJcp1r9ImCZIqCtv5NfwFvmLpXaqsV1d5WoYEXqqd1LS5W9t80nubC+gH77x1QJwHuagAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fold.png
// module id = 63
// module chunks = 0